import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const LayoutsView = angular
  .module('acme.view.application.layouts', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.layouts.membership',
    'acme.view.application.layouts.tickets',
    'acme.view.application.layouts.controllers',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const layouts = {
      name: 'application.layouts',
      url: '/layouts',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'LayoutsController',
          templateUrl: 'views/application/views/layouts/layouts.tpl.html',
        },
      },
    };

    $stateProvider.state(layouts);
  }).name;
